export function eventReadMore() {
	const readMoreToggle = document.querySelector('.event-read-more-toggle');

	if (readMoreToggle) {
		readMoreToggle.addEventListener('click', function(e) {
			e.preventDefault();

			const extendedContent = document.querySelector('.event-extended-content');
			const wrapper = this.closest('.event-read-more-wrapper');
			const isExpanded = wrapper.classList.contains('expanded');

			// Toggle expanded class
			wrapper.classList.toggle('expanded');
			extendedContent.classList.toggle('expanded');

			this.setAttribute('aria-expanded', !isExpanded);
		});
	}
}
